import Collection from '../collection'

class Patients extends Collection{
    create(options){
        return this.axios.post(`/organizations/${this.props.currentOrganization.id}/patients`, {
            ...options
        });
    }
    fetch(options = {}){
        let params = ''
        let id = ''
        if(options.accountID) params = `?accountID=${options.accountID}`
        if(options.id) id = `/${options.id}`
        delete options.id
        return this.axios.get(`/organizations/${this.props.currentOrganization.id}/patients${id}${params}`, {params:
            {...options}
        });
    }
    fetchActive(options = {}){
        options.active = true
        return this.axios.get(`/organizations/${this.props.currentOrganization.id}/patients`, {params:
            {...options}
        });
    }
}

export default Patients;